export default __webpack_public_path__ + "static/media/10 - Decaying Hexagons.fc05bbff.png";